import React from 'react';
import { Route } from 'react-router-dom';
import { Router } from 'react-router';
import { WithNavigation } from './navigation';
import styled, { ThemeProvider } from 'styled-components/macro';
import { PLAYER_ROUTES } from 'constants/player-routes';
import Search from '../containers/Search';
import DetailsTariffsPage from 'pages/DetailsTariffs';
import Details from '../containers/Details';
import withMenu from 'components/HOCs/withMenu';
import scaleSize from '../utils/scale-size';
import theme from '../themes/volia';
import GlobalStyles from './GlobalStyles';
import PlayerPage from 'pages/Player';
import FiltersPage from 'pages/Filters';
import GlobalLoaderContainer from '../containers/GlobalLoader';
import MouseControlsContainer from '../containers/MouseControls';
import Modal from '../containers/Modal';
import Toast from '../containers/Toast';
import ListGrid from '../containers/ListGrid';
import Overlay from '../containers/Overlay';
import EPGWidget from 'components/EPGWidget';
import withBackSupport from 'components/HOCs/withBackSupport';
import AuthorizationPage from 'pages/Auth';
import SeasonsPage from 'pages/Seasons';
import TermsPage from 'pages/Terms';
import TechnicalStubPage from 'pages/TechnicalStub';
import ParentalLockPage from 'pages/ParentalLock';
import ParentalLockPinPage from 'pages/ParentalLock/Pin';
import ParentalLockPurchasePage from 'pages/ParentalLock/Purchase';
import ParentalLockAgePage from 'pages/ParentalLock/Age';
import PackagesPage from 'pages/Profile/Packages';
import SearchAllPage from 'pages/SearchAll';
import LanguagesPage from 'pages/Profile/LanguagesPage';
import SettingsPage from 'pages/Profile/SettingsPage';
import AutostartTVPage from 'pages/Profile/SettingsPage/AutostartTvPage';
import PromocodePage from 'pages/Profile/PromocodePage';
import ContinueWatchingPage from 'pages/ContinueWatching';
import WatchlistPage from 'pages/Watchlist';
import PurchasesPage from 'pages/Purchases';
import SectionPage from 'pages/Section';
import useResolveDeeplink from 'hooks/useResolveDeeplink';
import useQueryCacheMonitoring from 'hooks/useQueryCacheMonitoring';
import ProfilePage from 'pages/Profile/ProfilePage';

const AppWrapper = styled.div`
  width: ${() => scaleSize(1920)}px;
  height: ${() => scaleSize(1080)}px;
  background-color: ${({ theme }) => theme.backgroundColor};
  color: ${({ theme }) => theme.mainTextColor};
  position: relative;
  overflow: hidden;
`;

const App = ({ history }) => {
  useQueryCacheMonitoring();
  useResolveDeeplink(history);

  return (
    <WithNavigation>
      <ThemeProvider theme={theme}>
        <AppWrapper>
          <GlobalLoaderContainer />
          <MouseControlsContainer />
          <Modal />
          <Toast />
          <Overlay />
          <GlobalStyles />
          <Router history={history}>
            <EPGWidget />
            <Route exact path={'/'} component={withMenu(SectionPage)} />
            <Route path={'/kids'} component={withMenu(SectionPage)} />
            <Route path={'/sport'} component={withMenu(SectionPage)} />
            <Route path={'/vod'} component={withMenu(SectionPage)} />
            <Route path={'/movies'} component={withMenu(SectionPage)} />
            <Route path={'/tv_series'} component={withMenu(SectionPage)} />
            <Route exact path={'/seasons/:contentType/:contentId'} component={withBackSupport(SeasonsPage)} />
            <Route path={PLAYER_ROUTES} component={PlayerPage} />
            <Route exact path={'/search'} component={withBackSupport(withMenu(Search))} />
            <Route exact path={'/search/all'} component={SearchAllPage} />
            <Route exact path="/filters" component={withMenu(FiltersPage, '@FILTERS')} />
            <Route exact path="/profile" component={withBackSupport(withMenu(ProfilePage))} />
            <Route path="/profile/authorization" component={withBackSupport(AuthorizationPage)} />
            <Route path="/profile/terms" component={withBackSupport(TermsPage)} />
            <Route path="/profile/packages" component={withBackSupport(PackagesPage)} />
            <Route exact path="/profile/parental-lock" component={withBackSupport(ParentalLockPage)} />
            <Route exact path="/profile/parental-lock/pin" component={withBackSupport(ParentalLockPinPage)} />
            <Route exact path="/profile/parental-lock/purchase" component={withBackSupport(ParentalLockPurchasePage)} />
            <Route exact path="/profile/parental-lock/age" component={withBackSupport(ParentalLockAgePage)} />
            <Route exact path="/profile/settings" component={SettingsPage} />
            <Route exact path="/profile/settings/languages" component={LanguagesPage} />
            <Route exact path="/profile/settings/autostarttv" component={withBackSupport(AutostartTVPage)} />

            <Route exact path="/profile/promocode/:code?" component={withBackSupport(PromocodePage)} />
            <Route path={'/purchases'} component={PurchasesPage} />
            <Route path="/continue-watching" component={ContinueWatchingPage} />
            <Route path="/watchlist" component={WatchlistPage} />
            <Route exact path={'/details/:contentType/:contentId'} component={withBackSupport(Details)} />
            <Route path={'/details/:contentType/:contentId/tariffs'} component={DetailsTariffsPage} />
            <Route path={'/list-grid/:listId'} component={withBackSupport(ListGrid)} />
            <Route exact path="/technical-stub" component={TechnicalStubPage} />
          </Router>
        </AppWrapper>
      </ThemeProvider>
    </WithNavigation>
  );
};

export default App;
